import Image               from '@widesk-ui/components/Image';
import FileImage           from '@/components/FileImage';
import fileStore           from '@/stores/fileStore';
import { ImageProps }      from '@widesk-ui/components/Image';
import WebsiteServiceModel from '@/models/WebsiteServiceModel';

type WebsiteModelImageProps = Omit<ImageProps, 'src'> & {
	index?: number;
	model?: WebsiteServiceModel | null;
	reference: Website_StonecodeFileTypeReference;
};

const WebsitePublicModelImage = (
	{ model, index = 0, reference, ...imageProps }: WebsiteModelImageProps,
) => {
	const ImageComponent = !model || model.hasIncludeFiles ? Image : FileImage;

	let imageComponentAttributes = {};

	if (model?.isLoaded) {
		imageComponentAttributes = !model || model.hasIncludeFiles
			? { src: model?.files[reference]?.at(index)?.url }
			: { file: fileStore.getFilesForModel(model, { fetchCollection: true }).at(index) };
	}

	return (
		<ImageComponent
			bordered
			style={{ background: 'white' }}
			preview={imageProps.size !== 'small'}
			{...imageComponentAttributes}
			{...imageProps}
		/>
	);
};

export default WebsitePublicModelImage;